<template>
  <div class="webdatalist">
    <f7-list media-list id="draft-list" class="itemList" style="font-size:16px">
      <div class="showSmallScreenOnly">
        <ul>
          <li v-for="draft in drafts" class="swipeout" @swipeout:deleted="deleteDraft(draft.idDraft)"
            :style="{background: getSeenStatusBackground('1')}">
            <div class="item-content swipeout-content draftTaphold boxRequest" :data-item="draft.idDraft" :data-complete="draft.isComplete" @click="createPayments(draft)">
              <div class="item-media">
                <i class="icon list-icon icon-edit"></i>
              </div>
              <div class="item-inner">
                <div class="item-title"><span style="font-size: 90%; color: orange;"><i  v-if="draft.versionNumber > 1" class="fa fa-exclamation-triangle"></i></span> {{ draft.draftName }}</div>
                <!-- Si le draft complet et pas encore validé, ou partiellement mais l'utilisateur actuel peut, alors on affiche waiting for validation-->
                <div class="item-subtitle" v-if="draft.isComplete === '1' && draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)">
                  <i class="fa fa-clock-o streammindBlueFont iconStatus"/> {{getLabelStatus(draft)}}
                </div>
                <!-- Si le draft est complet mais l'utilisateur ne peut pas valider, alors waiting for manager validation -->
                <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '2'">
                  <span style="color: orange;"><i class="fa fa-clock-o iconStatus"/></span> {{getLabelStatus(draft)}}
                </div>
                <!-- Ready to send -->
                <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '1'">
                  <i class="fa fa-check greenFont iconStatus"/> {{getLabelStatus(draft)}}
                </div>
                <!-- Needs to be completed -->
                <div class="item-subtitl" v-else-if="draft.isComplete === '0' || draft.isComplete === ''">
                  <i class="fa fa-pencil redFont iconStatus"/> {{getLabelStatus(draft)}}
                </div>
              </div>
              <div v-if="(draft.isValidated === '2' || draft.isValidated === '0') && draft.isValidator">
                <label style="margin-right: 30px; margin-top: 10px; font-size: 25px;"><i class="fa fa-exclamation-circle streammindBlueFont"></i></label>
              </div>
            </div>
            <div class="swipeout-actions-right">
              <a href="#" class="swipeout-delete"
                data-confirm="You won't be able to recover this draft from MoneyRoad"
                data-confirm-title="Remove?"
                data-close-on-cancel="true">
                Delete
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div class="showLargeScreenOnly">
        <li class="swipeout" :key="draft.idDraft" v-for="draft in drafts"
          :style="{background: getSeenStatusBackground('1')}">
          <div class="item-content draftTaphold boxRequest"
            :data-item="draft.idDraft"
            :data-complete="draft.isComplete"
            @click="createPayments(draft)">
            <div class="item-media">
              <!-- <f7-icon f7="compose_fill" class="streammindBlueFont"></f7-icon> -->
              <i class="icon list-icon icon-edit"></i>
            </div>
            <div class="item-inner col-4">
              <div class="item-title-row">
                <table>
                  <tr>
                    <td class="requestTitle">
                      {{draft.draftName}}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="item-title-row">
                <span class="versionSubTitle">
                  <span style="font-size: 90%; color: orange;">
                    <i v-if="draft.versionNumber > 1" class="fa fa-exclamation-triangle"></i>
                  </span>
                  Version {{draft.versionNumber}}
                </span>
              </div>
            </div>
            <div class="col-10">
              <table>
                <tr>
                  <td class="">
                    <!-- Ready to send -->
                    <div class="item-subtitle" v-if="draft.isComplete === '1' && draft.isValidated === '1'">
                      <i class="fa fa-check iconStatus greenFont"/> {{getLabelStatus(draft)}}
                    </div>
                    <!-- Needs to be completed -->
                    <div class="item-subtitle" v-else-if="draft.isComplete === '0' || draft.isComplete === ''">
                      <i class="fa fa-pencil iconStatus redFont"/> {{getLabelStatus(draft)}}
                    </div>
                    <!-- Si le draft complet et pas encore validé, ou partiellement mais l'utilisateur actuel peut, alors on affiche waiting for validation-->
                    <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)">
                      <i class="fa fa-clock-o iconStatus streammindBlueFont"/> {{getLabelStatus(draft)}}
                    </div>
                    <!-- Si le draft est complet mais l'utilisateur ne peut pas valider, alors waiting for manager validation -->
                    <div class="item-subtitle" v-else-if="draft.isComplete === '1' && draft.isValidated === '2'">
                      <i class="fa fa-clock-o iconStatus orangeFont"/> {{getLabelStatus(draft)}}
                    </div>
                  </td>
                  <td class="statusLabel2" v-if="(draft.isValidated === '2' || draft.isValidated === '0') && draft.isValidator">
                    <label>
                      <i class="fa fa-exclamation-circle iconStatus streammindBlueFont"></i>
                      <span style="font-size: 15px;">{{ $t('directPayments.vldtn_rqrd') }}</span>
                    </label>
                  </td>
                </tr>
              </table>
            </div>
            <div class="item-media col-1" v-if="false">
              <button class="button-swipe-out button-big button-bank-account boxRequest" onclick="event.stopPropagation()" @click="deleteDraftWebIHM(draft.idDraft)">
                <!-- <i class="fa fa-times-circle button-delete" ></i> -->
                <f7-icon f7="close_round" class="button-delete"></f7-icon>
              </button>
            </div>
          </div>
        </li>
      </div>
    </f7-list>
  </div>
</template>

<script>
import Status from '@/helpers/status.js'
import {getSeenStatusBackground} from '@/helpers/labels'
import {errorMessageAlert} from '@/helpers/alert'
// import dpCreateTemplate from '../../requests/creationPages/DPCreateTemplate.vue'
import {loadPage} from '@/helpers/routing'
import {statusLabel} from '@/helpers/labels.js'

export default {
  name: 'DraftList',
  props: ['drafts'],
  data: () => {
    return {
      isValidator: false
    }
  },
  created () {
  },
  beforeMount () {
  },
  updated () {
  },
  computed: {
  },
  methods: {
    createPayments (draft) {
      let that = this
      that.$engine.settings.set({preChargedDraft: draft})
      loadPage(that, {url: '/directPayments/draft/edit/'})
    },
    deleteDraft (idDraft) {
      let that = this
      that.$engine.dpDrafts
      .del(idDraft)
      .then(() => {
        that.$f7.alert('', 'Draft Removed')
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
    },
    deleteDraftWebIHM (idDraft) {
      let that = this
      this.$f7.modal({
        title: 'Delete ?',
        text: 'You won\'t be able to recover this draft from MoneyRoad',
        buttons: [
          {
            text: 'Cancel',
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: 'Yes',
            onClick: function () {
              var idDraftInList = -1
              for (var i = 0; i < that.drafts.length; i++) {
                if (that.drafts[i].idDraft === idDraft) {
                  idDraftInList = i
                  break
                }
              }
              that.drafts.splice(idDraftInList, 1)
              that.deleteDraft(idDraft)
            }
          }
        ]
      })
    },
    getLabelStatus (draft) {
      if (draft.isComplete === '1') {
        if (draft.isValidated === '1') {
          return statusLabel(this.$i18n, Status.DRAFT_READY_TO_SEND)
        } else if (draft.isValidated === '0' || (draft.isValidated === '2' && draft.isValidator)) {
          return statusLabel(this.$i18n, Status.DRAFT_WAITING_VALIDATION)
        } else {
          return statusLabel(this.$i18n, Status.DRAFT_WAITING_UPPER_VALIDATION)
        }
      } else {
        return statusLabel(this.$i18n, Status.DRAFT_NEED_COMPLETED)
      }
    },
    getSeenStatusBackground (isRead) {
      return getSeenStatusBackground(isRead)
    }
  }
}
</script>

<style scoped>
li {
  background-color: white;
  list-style: none;
}

.statusLabel2 {
  padding-top: 10px;
  padding-left: 150px
}

.iconStatus {
  font-size: 17px;
}

.versionSubTitle {
  margin-left: 5px;
  color: grey;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// DPDraftList.vue?13debee9